export default __webpack_public_path__ + "static/4-c0913cf9c980f2a08950e46db9d5464d.webp";